export default "/images/bd2aceb65446830ae3a39d97fdba0d51.avif";